import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { stripeConfig, API_URLS } from './config';
import './AccountPage.css';
import fetchWithAuth from './api';

const AccountPage = ({ user, userPermissions }) => {
  const [email, setEmail] = useState('');
  const [expiryDate, setExpiryDate] = useState('N/A');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserAccountInfo = async () => {
      try {
        const response = await fetchWithAuth(API_URLS.GetUserPermissions, user, userPermissions);
        if (!response.ok) {
          throw new Error('Failed to fetch user permissions');
        }
        const data = await response.json();
        
        if (data.expiryDate) {
          const expiration = new Date(data.expiryDate);
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Normalize today to start of day

          if (expiration < today) {
            setExpiryDate('Expired');
          } else {
            setExpiryDate(expiration.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }));
          }
        } else {
          setExpiryDate('N/A');
        }
      } catch (error) {
        console.error('Error fetching user account info:', error);
        // Optionally, set error state or display a toast message
      }
    };

    if (user && userPermissions) {
      setEmail(user.email || '');
      fetchUserAccountInfo();
    }
  }, [user, userPermissions]);

  return (
    <div className="account-page">
      <h1>Account Information</h1>
      <div className="account-form">
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <span id="email">{email}</span>
        </div>
        <div className="form-group">
          <label>Expiry Date:</label>
          <span>{expiryDate}</span>
        </div>
      </div>

      <div className="subscription-info">
        <h3>Choose your plan:</h3>
        <div className="plan-options">
          <div className="plan-card basic-plan">
            <h4>Plan 30 ($3.49)</h4>

            <ul>
              <li>Create option strategies and evaluate option strategies</li>
              <li>Access members-only videos and tutorials</li>
              <li>Adds 30 days to your membership</li>
            </ul>     
            <button className="btn-subscribe-premium" onClick={() => navigate('/checkout', { state: { priceId: stripeConfig.BasicPlan } })}>Buy 30-Day Membership Extension</button>
            <p className='free-trial-note'>One-time purchase · No recurring charges</p>
          </div>
          <div className="plan-card premium-plan">
            <div className="most-popular-badge">Most Popular</div>
            <h4>Plan 360 ($29.99)</h4>
            <ul>
              <li>Create option strategies and evaluate option strategies</li>
              <li>Access members-only videos and tutorials</li>
              <li>Adds 360 days to your membership</li>
            </ul>    
            <button className="btn-subscribe-premium" onClick={() => navigate('/checkout', { state: { priceId: stripeConfig.PremiumPlan } })}>Buy 360-Day Membership Extension</button>
            <p className='free-trial-note'>One-time purchase · No recurring charges</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
